import React from "react";

type AlertColor = 'red' | 'green' | 'yellow' | 'blue';

interface AlertComponentProps {
    open: boolean;
    onClose: () => void;
    color?: AlertColor;
    message?: string;
}

export const AlertComponent: React.FC<AlertComponentProps> = ({ open, onClose, color = "red", message }) => {
    if (!open) return null;

    const colorMap: Record<string, string> = {
        red: "bg-[#FEE2E2] text-[#7F1D1D] border-[#FCA5A5]",
        green: "bg-[#D1FAE5] text-[#065F46] border-[#6EE7B7]",
        yellow: "bg-[#FEF3C7] text-[#78350F] border-[#FCD34D]",
        blue: "bg-[#DBEAFE] text-[#1E3A8A] border-[#93C5FD]",
    };

    const colorClasses = colorMap[color] || colorMap.red;

    return (
        <div className={`relative flex items-center justify-between border rounded-md p-4 ${colorClasses}`}>
            <div className="text-[14px] flex-nowrap overflow-hidden text-ellipsis max-w-[320px] max-lg:w-[400px] max-2xl:w-[500px]">
                {message}
            </div>
            <button onClick={onClose} className="ml-4 text-inherit hover:opacity-70 transition-opacity" aria-label="Close alert">
                <svg width="12" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.4912 2.85962L12.3364 10L19.4912 17.1404C19.6504 17.2938 19.7773 17.4773 19.8647 17.6803C19.952 17.8832 19.998 18.1014 19.9999 18.3223C20.0019 18.5431 19.9597 18.7621 19.8759 18.9666C19.7921 19.171 19.6683 19.3567 19.5118 19.5128C19.3554 19.669 19.1693 19.7925 18.9644 19.8761C18.7596 19.9598 18.5401 20.0019 18.3189 19.9999C18.0976 19.998 17.8789 19.9521 17.6755 19.865C17.4722 19.7778 17.2883 19.6511 17.1345 19.4922L9.97952 12.352L2.82452 19.4922C2.51018 19.7952 2.08918 19.9628 1.65218 19.9591C1.21519 19.9553 0.797169 19.7803 0.488156 19.472C0.179142 19.1636 0.00386037 18.7464 6.30041e-05 18.3103C-0.00373436 17.8742 0.164257 17.4541 0.467854 17.1404L7.62269 10L0.467854 2.85962C0.164257 2.54593 -0.00373436 2.12579 6.30041e-05 1.68968C0.00386037 1.25358 0.179142 0.836417 0.488156 0.528035C0.797169 0.219653 1.21519 0.044729 1.65218 0.0409394C2.08918 0.0371498 2.51018 0.204798 2.82452 0.507774L9.97952 7.64798L17.1345 0.507774C17.2883 0.348916 17.4722 0.222205 17.6755 0.135035C17.8789 0.0478651 18.0976 0.0019819 18.3189 6.27998e-05C18.5401 -0.0018563 18.7596 0.0402267 18.9644 0.123857C19.1693 0.207487 19.3554 0.330989 19.5118 0.487157C19.6683 0.643325 19.7921 0.829032 19.8759 1.03344C19.9597 1.23785 20.0019 1.45687 19.9999 1.67771C19.998 1.89856 19.952 2.11681 19.8647 2.31974C19.7773 2.52266 19.6504 2.70619 19.4912 2.85962Z" fill="currentColor" />
                </svg>
            </button>
        </div>
    );
};
